<template>
  <div id="Domestic">
    <form id="KSPayWeb" action="" method="post">
      <div class="content-container">
        <div class="content-item">
          <h1 class="title">{{ $t('CERTIFICATION.TITLE') }}</h1>
          <div class="input-container">
            <div class="input-box">
              <div class="input-title" @click="test">{{ $t('CERTIFICATION.ORDERER_NAME') }}</div>
              <div class="input-wrap">
                <input type="text" name='sndOrdername' inputmode="email" class="input-item" v-model="certification.ordererName">
              </div>
            </div>
            <div class="input-box">
              <div class="input-title" @click="() => { testMode++ }">{{ $t('CERTIFICATION.EMAIL') }}</div>
              <div class="input-wrap">
                <input type="email" name="sndEmail" inputmode="email" class="input-item" v-model="certification.email">
              </div>
            </div>
            <div class="input-box">
              <div class="input-title">{{ $t('CERTIFICATION.MOBILE_PHONE') }}</div>
              <div class="input-wrap">
                <input type="tel" name="sndMobile" inputmode="email" class="input-item" v-model="certification.mobilePhone">
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <div class="hidden-form">
        <select name=sndPaymethod>
          <option value="1000000000" selected>신용카드</option>
          <option value="0100000000">가상계좌</option>
          <option value="0010000000">계좌이체</option>
          <option value="0000010000" >휴대폰결제</option>
        </select>
        <input type='text' name='sndStoreid' value='2999199999' size='15' maxlength='10'> - 상점 아이디
        <input type='text' name='sndOrdernumber' :value='GET_PAYMENT_QUERY.order_no' size='30'> - 주문 번호
        <input type='text' name='sndGoodname' :value='GET_PAYMENT_INFORMATION.title' size='30'> - 상품명
        <input type='text' name='sndAmount' :value='GET_PAYMENT_INFORMATION.amount' size='15' maxlength='9'> - 금액
        <input type='text' name='sndMinAmount' :value='100' size='15' maxlength='9'> - 금액

        <input type=hidden	name=sndReply :value="GET_PAYMENT_INFORMATION.payload.error_url">
        <input type=hidden  name=sndGoodType value="1"> 	 <!-- 상품유형: 실물(1),디지털(2) -->
        <input type=hidden  name=sndCharSet value="utf-8"> <!-- 가맹점 charset 설정변수 (euc-kr / utf-8) -->
      </div>

      <div class="button-container">
        <input type="button" :value="$t('COMMON.NEXT')" class="next-step" :class="{ 'hide': !visibleBtnNext }" :style="styleObject" @click="submitPay" :disabled="disabledButtonNext">
      </div>
    </form>
    <!-- <button @click="test">test mode</button> -->
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
  data () {
    return {  
      certification: {
        ordererName: '',
        email: '',
        mobilePhone: ''
      },
      visibleBtnNext: true,
      detectCloseButton: {},
      testMode: 0
    }
  },
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor',
      'GET_PAYMENT_INFORMATION': 'GET_PAYMENT_INFORMATION',
      'GET_PAYMENT_QUERY': 'GET_PAYMENT_QUERY'
    }),
    styleObject: function() {
      return {
        '--color': this.getColor.primaryColor,
        '--color-active': this.getColor.primaryColorDark
      }
    },
    disabledButtonNext() {
      if(this.certification.ordererName === '' || this.certification.email === '' || this.certification.mobilePhone === '') {
        return true;
      } 
      return false
    }
  },
  created() {
    console.log(this.GET_PAYMENT_QUERY, this.GET_PAYMENT_INFORMATION);
    this.initIFrameCloseEvent();
  },
  destroyed() {
    // clearInterval(this.detectCloseButton)
  },
  methods: {
    ...vuex.mapActions({
      'SET_ERROR_PAGE': 'SET_ERROR_PAGE'
    }),
    nextStep() {
      console.log('test')
    },
    isMobile() {
      return navigator.userAgent.indexOf('Mobi') > -1;
    },
    submitPay() {
      let doc = document.querySelector('#KSPayWeb');

      this._submit(doc)
    },
    _submit(_frm)	{
      // _frm.sndReply.value = this.getLocalUrl("kspay_wh_rcv.jsp");
      _frm.sndReply.value = `https://${location.hostname}/page/failure`;

      console.log(this.isMobile())
      if(this.isMobile()) {
        console.log('mobile')
        this._pay(_frm);
      } else {
        console.log('desktop')
        _pay(_frm);
      }
    },
    getLocalUrl(mypage) { 
      var myloc = location.href; 
      console.log(myloc, myloc.substring(0, myloc.lastIndexOf('/')) + '/' + mypage)
      return myloc.substring(0, myloc.lastIndexOf('/')) + mypage;
    },
    goResult(){
      console.log('goResult')
      document.KSPayWeb.target = "";
      document.KSPayWeb.action = "./kspay_wh_result.jsp";
      document.KSPayWeb.submit();
    },
    eparamSet(rcid, rctype, rhash){
      console.log('eparamSet')
      document.KSPayWeb.reWHCid.value 	= rcid;
      document.KSPayWeb.reWHCtype.value = rctype  ;
      document.KSPayWeb.reWHHash.value 	= rhash  ;
    },
    mcancel()	{
      // 취소
      closeEvent();
    },
    _pay(_frm) {
      // sndReply는 kspay_wh_rcv.jsp (결제승인 후 결과값들을 본창의 KSPayWeb Form에 넘겨주는 페이지)의 절대경로를 넣어줍니다. 
      _frm.sndReply.value           = this.getLocalUrl("kspay_wh_result.jsp") ;

      var agent = navigator.userAgent;
      var midx		= agent.indexOf("MSIE");
      var out_size	= (midx != -1 && agent.charAt(midx+5) < '7');

      //_frm.target = '_blank';
      _frm.action ='https://kspay.ksnet.to/store/KSPayMobileV1.4/KSPayPWeb.jsp';
      
      _frm.submit();
    },
    test() {
      if(this.testMode > 0) {
        this.route();  
      }
    },
    route() {
      console.log('route')
      let port = "8080"
      let query = `/?order_no=${this.GET_PAYMENT_QUERY.order_no}&api_key=${this.GET_PAYMENT_QUERY.api_key}&token=${this.GET_PAYMENT_QUERY.token}`
      let url = `http://localhost:${port}${query}`
      location.href = url;
    },
    initIFrameCloseEvent() {
      console.log(this.GET_PAYMENT_INFORMATION.payload.error_url);
      window.mcancel = () => {
        let url = this.GET_PAYMENT_INFORMATION.payload.error_url;
        location.replace(url)
      };

      window.goResult = () => {
        let url = this.GET_PAYMENT_INFORMATION.payload.error_url;
        location.replace(url)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../card/card.scss';

#Domestic {
  .input-wrap {
    position: relative;
  }

  .card-validity {
    position: absolute;
    // top: 28px;
    left: -2000px;
    height: 50px;

    color: transparent;

   &:focus ~ .validity-date {
      .cursor {
        animation: cursor-literals infinite 1s linear;        
      }
    }

    @keyframes cursor-literals {
      from {
        color: $color-black-30;
      }

      50% {
        color: var(--color);
      }

      to {
        color: $color-black-30;
      }
    }
  }

  .validity-date {
    line-height: 50px;

    .date-number {
      color: $color-black-30;
    }

    .filled {
      color: black;
    }   
  }

  .hidden-form {
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
}
</style>